export enum SampleTrackingStatus {
  AWAITING = 'AWAITING',
  RECEIVED = 'RECEIVED',
  IN_SEQUENCING = 'IN_SEQUENCING',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RECOLLECT = 'RECOLLECT',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
}

export enum SampleTrackingType {
  BLOOD = 'BLOOD',
  SALIVA = 'SALIVA',
  BUCCAL_SWAB = 'BUCCAL_SWAB',
}

export interface SampleTrackingResponse {
  meta: SampleTrackingResponseMeta;
  data: SampleTracking[];
}

export interface SampleTrackingResponseMeta {
  hasMorePages?: boolean;
}

export interface SampleTracking {
  failureReason: string;
  kitId: string;
  patientId: string;
  orderId: string;
  sampleType: SampleTrackingType;
  status: SampleTrackingStatus;
  statusDate: string;
}
